export default {
  namespaced: true,
  state: {
    insuranceList: [] // 保险信息列表
  },
  actions: {
    // 新增保险信息
    async addInsurance({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'POST',
          url: '/organize/insurance/info',
          data: data,
          msg: '新增保险信息成功'
        },
        { root: true }
      )
      return res
    },
    // 删除保险信息
    async deleteInsurance({ dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'DELETE',
          url: '/organize/insurance/info',
          data: { uid: uid },
          msg: '删除保险信息成功'
        },
        { root: true }
      )
      return res
    },
    /* // 获取保险信息列表
    async getInsuranceList({ commit, dispatch }, uid) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'GET',
          url: '/person/cultivate/checklist',
          data: { eventUid: uid }
        },
        { root: true }
      )
      var insuranceList = res.data ? res.data : []
      commit(
        'baseSet',
        { module: 'insurance', key: 'insuranceList', value: insuranceList },
        { root: true }
      )
    }, */
    // 编辑保险信息
    async editInsurance({ dispatch }, data) {
      const res = await dispatch(
        'baseRequest',
        {
          method: 'PUT',
          url: '/organize/insurance/info',
          data: data,
          msg: '编辑保险信息成功'
        },
        { root: true }
      )
      return res
    }
  }
}
